import { ActionConfigurationsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ActionConfigurationElement, getIdentifierEnumFromString } from 'modules/processes/domain'

export const useActionConfigurations = () => {
  const { data, loading } = useQuery(ActionConfigurationsDocument)

  const actions: ActionConfigurationElement[] =
    data?.processes.actionConfigurationsConnection.edges
      ?.map((edge) => {
        const action = edge.node
        const identifier = getIdentifierEnumFromString(action.identifier)

        if (identifier && action.enabled) return { ...action, identifier }
      })
      .filter(Boolean) ?? []

  return {
    loading,
    actions,
  }
}
